import React from "react";
// import 'useForm' from '../../src/useForm';
import "../styles/FormInput.css";
import useForm from "./useForm";
import "../styles/Form.css";
import validate from "./validateInfo";

function FormInput({ submitForm }) {
  const { handleChange, values, handleSubmit, errors, showSuccess } = useForm(
    submitForm,
    validate
  );

  // Define level options matching backend choices
  const levelOptions = [
      { value: 'beginner_no_exp', label: 'Beginner (No Experience)' },
      { value: 'beginner_exp', label: 'Beginner (With Experience)' },
      { value: 'intermediate', label: 'Intermediate' },
  ];

  return (
    <div className="form-container">
      <form onSubmit={handleSubmit} className="form-info" noValidate>
        <div className="main-container">
          <h3>
            Join the Waitlist!
            Fill in the details below to get notified about the next cohort.
          </h3>
          <div className="forminput-container">
            <div className="form-inputs">
              <label htmlFor="fullname" className="form-label">
                Full Name:
              </label>
              <br />
              <input
                id="fullname"
                type="text"
                name="fullname"
                className="font-input"
                placeholder="Enter your full name"
                value={values.fullname}
                onChange={handleChange}
              />
              {errors.fullname && <p>{errors.fullname}</p>}
            </div>

            <div className="form-inputs">
              <label htmlFor="email" className="form-label">
                Email address:
              </label>
              <br />
              <input
                id="email"
                type="email"
                name="email"
                className="font-input"
                placeholder="Enter your email address"
                value={values.email}
                onChange={handleChange}
              />
              {errors.email && <p>{errors.email}</p>}
            </div>

            <div className="form-inputs">
              <label htmlFor="github" className="form-label">
                Github Username:
              </label>
              <br />
              <input
                id="github"
                type="text"
                name="github"
                className="font-input"
                placeholder="Enter your github username"
                value={values.github}
                onChange={handleChange}
              />
              {errors.github && <p>{errors.github}</p>}
            </div>

            <div className="form-inputs">
              <label htmlFor="level" className="form-label">
                What is your current level?
              </label>
              <br />
              <select
                id="level"
                name="interest"
                className="font-input"
                value={values.interest || 'beginner_no_exp'}
                onChange={handleChange}
                required
              >
                {levelOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="form-text">
            <h3>Agreement with DataEpic</h3>

            <p>
              By submitting this application, you agree to allow us to send you
              updates on your 
              application and other relevant information. <br /> You also consent to
              potential contact for project and employment opportunities.
            </p>
          </div>
          {errors.api && (
            <div className="api-error-message">
              <p>{errors.api}</p>
            </div>
          )}
          {showSuccess && (
            <div className="api-success-message">
              <p>✅ Successfully added to waitlist! We'll notify you about the next cohort.</p>
            </div>
          )}
          <div className="btn-container">
            <button className="form-input-btn" type="submit">
              Submit
            </button>
            <br />
            
          </div>
        </div>
      </form>
    </div>
  );
}

export default FormInput;
